import { Link, useParams } from 'react-router-dom';

import PageNotFound from 'components/PageNotFound/PageNotFound';
import defaultImage from 'assets/images/containerNotFound.jpg';

// import PropTypes from 'prop-types';
import s from './ContainersWrapper.module.css';

export default function ContainersWrapper({ containers, link }) {
  const params = useParams();
  return (
    <>
      {!containers && <PageNotFound />}
      {containers && (
        <ul className={s.list} id="containers">
          {Object.values(containers)?.map(({ id, title, posterPath }) => (
            <li key={id} className={s.item}>
              <Link
                to={
                  link
                    ? `/containers/${params.category}/${id}`
                    : `/containers/${id}`
                }
              >
                <img
                  src={
                    posterPath
                      ? `${window.location.origin}/${posterPath}`
                      : defaultImage
                  }
                  alt={title}
                  className={s.itemImage}
                />
                <p className={s.info}>{title}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}

// ContainersWrapper.propTypes = {
//   containers: PropTypes.objectOf(
//     arr(
//       PropTypes.shape({
//         id: PropTypes.string.isRequired,
//         posterPath: PropTypes.string,
//         title: PropTypes.string.isRequired,
//       })
//     )
//   ),
//   link: PropTypes.bool,
// };
